import { dsClass } from '../../common/constants/dsClasses';
import { Icon } from '../Icon/Icon';

import './ValidationMessage.scss';

export interface ValidationMessageProps {
  message: string;
}

export const ValidationMessage = ({ message }: ValidationMessageProps) => {
  return (
    <div className={`${dsClass.INPUTERROR} of-validation-message`}>
      <Icon
        icon="error"
        size="s"
        type="regular"
        className={`${dsClass.INPUTERROR} of-validation-message--icon`}
        color="red-600"
      />
      {message}
    </div>
  );
};
